/** Combined order subpackage messages — English */
export default {
  combinedOrder: {
    nav: {
      confirmTitle: 'Confirm order',
      detailTitle: 'Order details',
      combinedOrderTitle: '{ticketType} + hotel bundle',
      unionDetailTitle: 'Bundle order details',
    },
    banner: {
      couponTitle: 'Estimated {amount} CNY coupon with no minimum spend',
      couponDesc: 'View in My Coupons after order completion',
      installmentTitleIndex: '{period}-month interest-free',
      installmentTitleDetail: 'Up to {period}-month interest-free',
      installmentDesc: 'Bundle checkout for installment benefits',
    },
    orderType: {
      tag: '{ticketType} + hotel bundle',
      plane: 'Flight',
      internationalPlane: 'International flight',
      train: 'Train',
      fallback: 'Order',
    },
    ticket: {
      infoTitle: '{ticketType} info',
      detail: 'Details',
      outbound: 'Outbound',
      return: 'Return',
      refundDetail: 'Change & refund',
      refundRules: 'Change & refund policy',
      stopover: 'Stops >',
      pricePerPerson: '￥{amount}/person',
      route: 'Route',
      date: 'Date',
      fee: '{ticketType} fee',
      routeFallback: 'Trip info',
      flightDetailTitle: 'Flight details',
      totalDuration: 'Total duration {duration}',
      stopoverMinutes: 'Stopover: {time}',
      ticketPriceTimes: 'Fare × {count} passenger(s)',
      priceTimesPerson: '￥{price}×{count} passenger(s)',
      priceTimesRoom: '￥{price} × {count} room(s)',
      priceTimesNightsRooms: '￥{price} × {nights} night(s) × {count} room(s)',
      trainDetailTitle: 'Train details',
      trainNoInfo: 'Train info',
      departureDate: 'Departure date',
      seatInfo: 'Seat info',
      seatType: 'Seat class',
      ticketPrice: 'Fare',
      selectedSeats: 'Selected seats',
      berthSelection: 'Berth selection',
      seatPreference: 'Seat preference',
      cardTagPlane: 'Flight',
      cardTagTrain: 'Train',
      flightAmount: 'Flight amount',
      serviceFee: 'Service fee',
    },
    passenger: {
      infoTitleTrain: 'Passenger info',
      infoTitlePlane: 'Passenger info',
      sectionTitleTrain: 'Passengers',
      sectionTitlePlane: 'Passengers',
      sectionSuffix: ' info',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      noChildSupport: 'This flight does not support child passengers',
      addTrain: 'Add passenger',
      addPlane: 'Add passenger',
      typeAdult: 'Adult',
      typeChild: 'Child',
      typeStudent: 'Student',
      typeDisabledMilitary: 'Disabled military',
      typeInfant: 'Infant',
      trainTicketAdult: 'Adult ticket',
      trainTicketChild: 'Child ticket',
      trainTicketStudent: 'Student ticket',
      trainTicketDisabledMilitary: 'Disabled military ticket',
      idCard: 'ID card',
      passport: 'Passport',
      militaryId: 'Military ID',
      hkmPass: 'HK/Macau pass',
      taiwanCompatriot: 'Taiwan compatriot pass',
      homeReturnPermit: 'Home return permit',
      idNumber: 'ID number',
      selectPassenger: 'Please select passengers',
      selectPlanePassenger: 'Please select passengers',
      childAloneTrain: 'Children cannot travel alone; at least one adult is required',
      childAlonePlane: 'Children cannot fly alone; at least one adult is required',
      hotelContactFromFirst:
        'Hotel contact defaults to the selected passenger (adult preferred). You can edit it in the hotel booking section below.',
    },
    insurance: {
      serviceTitle: 'Insurance',
      accidentTitle: 'Flight accident insurance',
      delayTitle: 'Flight delay insurance',
      noInvoice: 'No invoice',
      noCoverage: 'No coverage',
      insuredLabel: 'Policyholder',
      selectInsured: 'Select policyholder',
      viewEdit: 'View / edit',
      adultOnlyTip: 'Policyholder must be 18 or older',
      feeWithCount: 'Insurance ({count} passengers)',
      feeTimesCount: 'Insurance x{count}',
      fallbackName: 'Flight accident insurance',
      selectInsuredTitle: 'Select policyholder',
      addInsured: 'Add policyholder',
      purchasedServices: 'Purchased / complimentary services',
      label: 'Insurance',
      statusPending: 'Pending',
      statusProcessing: 'Processing',
      statusSuccess: 'Issued',
      statusFailed: 'Failed',
      statusRefundSuccess: 'Refunded',
      statusRefundFailed: 'Refund failed',
      statusRefunding: 'Refunding',
      statusCancelled: 'Cancelled',
      statusRescheduleSuccess: 'Reschedule insured',
      statusRescheduleFailed: 'Reschedule insurance failed',
      statusUnknown: 'Unknown status',
    },
    seat: {
      onlineSelection: 'Online seat selection',
      legendTitle: 'Seat legend',
      available: 'Available',
      selected: 'Selected',
      window: 'Window',
      aisle: 'Aisle',
      upperBerth: 'Upper berth',
      upperBerthDesc: 'Lower price, smaller space',
      middleBerth: 'Middle berth',
      middleBerthDesc: 'Moderate price, easy access',
      lowerBerth: 'Lower berth',
      lowerBerthDesc: 'Higher price, more comfort',
      windowSide: 'Window seat',
      windowSideDesc: 'Enjoy the scenery',
      aisleSide: 'Aisle seat',
      aisleSideDesc: 'Easy to move around',
      selectedSeatsLabel: 'Selected seats:',
      preferenceLabel: 'Seat preference:',
      clear: 'Clear',
      sectionTitle: 'Seat selection',
      detailSleeperTitle: 'Sleeper selection',
      detailPreferenceTitle: 'Seat preference',
      preferenceNotice: 'This reflects your preference at booking; actual seats may differ',
      berthSelectedSummary: '{selected} berth(s) selected / {total} required',
      preferenceSelectedSummary: '{selected} preference(s) selected / {total} required',
      selectedSeatsHeader: 'Selected seats ({selected}/{total})',
      businessSeatTitle: 'Business class seat selection',
      firstSeatTitle: 'First class seat selection',
      secondSeatTitle: 'Second class seat selection',
    },
    trainOptions: {
      title: 'Ticket options',
      acceptNoSeat: 'Accept standing',
      acceptNoSeatDesc: 'Buy standing ticket if this seat class is sold out',
      yes: 'Yes',
      no: 'No',
    },
    hotel: {
      infoTitle: 'Hotel info',
      roomDetail: 'Room details',
      reservationTitle: 'Booking info',
      roomCount: 'Rooms',
      roomCountValue: '{count} room(s)',
      roomNightsSummary: '{rooms} room(s) {nights} night(s)',
      maxGuests: 'Up to {count} guest(s)',
      roomFeeRoomsNights: 'Room fee {rooms} room(s) × {nights} night(s)',
      arriveAfter: 'After {time}',
      arriveBefore: 'Before {time}',
      guestName: 'Guest name',
      guestNamePlaceholder: 'Guest name for room {index}',
      nameGuideTitle: 'Name guide:',
      lastNameGuide: 'Last name: English or pinyin, e.g. li',
      firstNameGuide: 'First name: English or pinyin, e.g. hao',
      roomGuestTitle: 'Room {index} guest info',
      lastName: 'Last name',
      firstName: 'First name',
      lastNamePlaceholder: 'e.g. li',
      firstNamePlaceholder: 'e.g. hao',
      contactPhone: 'Contact phone',
      contactPhonePlaceholder: 'Enter contact phone',
      fee: 'Hotel fee',
      refundTip: 'Reminder: cancelling hotel after a successful bundle booking incurs an extra 3% platform fee',
      cardTag: 'Hotel',
      contactHotel: 'Contact hotel',
      facilitiesPolicy: 'Facilities & policy',
      map: 'Map',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      nights: '{count} night(s)',
      roomInfoTitle: 'Room info',
      guestLabel: 'Guests',
      remark: 'Remarks',
      roomFallback: 'Room',
      roomFeeNights: 'Room fee ({nights} night(s))',
      dateMonthDay: '{month}/{day}',
      nonRefundable: 'Non-refundable',
      afterBookingSuccess: 'After booking confirmed',
      freeCancel: 'Free',
      floorSuffix: 'F',
    },
    price: {
      detailTitle: 'Price breakdown',
      detailShort: 'Details',
      viewDetail: 'View details',
      adultTicketTimes: 'Adult fare x{count}',
      childTicketTimes: 'Child fare x{count}',
      serviceFeeTimes: 'Service fee x{count}',
      subtotal: '{ticketType} subtotal',
      total: 'Total',
      amountDetailTitle: 'Amount details',
      planeFeeTitle: 'Flight fee',
      trainFeeTitle: 'Train fee',
      adult: 'Adult',
      child: 'Child',
      planeTicket: 'Flight',
      airportFee: 'Airport fee',
      fuelTax: 'Fuel surcharge',
      roomFee: 'Room fee',
      payableAmount: 'Amount due',
      paid: 'Paid',
      orderDetailTitle: 'Order breakdown',
      mainCouponLabel: 'Bundle coupon',
      insuranceFeeTimesPerson: 'Insurance × {count} passenger(s)',
    },
    coupon: {
      title: 'Coupon',
      discountFallback: 'Coupon discount',
      availableCount: '{count} available',
      noneAvailable: 'No coupons available',
      selectTitle: 'Select coupon',
      doNotUse: 'Do not use coupon',
      validUntil: 'Valid until: {time}',
      discountUnit: ' off',
      subLabel: '┗ Coupon',
      noThreshold: 'No minimum',
      fullReduction: 'Spend {minAmount}, save {amount}',
      instantReduction: 'Save {amount} CNY',
      fullDiscount: 'Spend {minAmount}, {discount}% off',
      percentDiscount: '{discount}% off',
      fallback: 'Coupon',
      selectedToast: 'Coupon applied, save ￥{amount}',
    },
    payment: {
      title: 'Payment method',
      combinedTitle: 'Bundle payment',
      combinedDesc: 'Pay {ticketType} + hotel together for installment benefits',
      ticketOnlyTitle: 'Pay {ticketType} only',
      ticketOnlyDesc: 'Pay {ticketType} only; book hotel later',
      submitOrder: 'Submit order',
      payNow: 'Pay now',
      cancelOrder: 'Cancel order',
    },
    installment: {
      agreePrefix: 'I have read and agree to',
      noticeLink: 'Installment Terms',
      noticeTitle: 'Installment Terms',
      agreeCheckbox: 'I have read and agree to the Installment Terms',
      intro: 'Please read and understand the following. By using flight/train + hotel bundle payment with credit card installment, you agree to all terms.',
      section1Title: '1. Installment service',
      section1Item1: '1.1 Available only when purchasing flight + hotel or train + hotel in one order via bundle payment.',
      section1Item2: '1.2 Eligible orders with 3-month credit card installment enjoy 0 handling fee (interest-free).',
      section1Item3: '1.3 Paying flight, train, or hotel separately does not qualify.',
      section2Title: '2. Eligibility & changes',
      section2Item1: '2.1 Interest-free eligibility applies upon successful payment. Failed payment, cancellation, or refund voids the benefit.',
      section2Item2: '2.2 Partial refund (e.g. hotel only) may void interest-free status; fees per bank statement.',
      section3Title: '3. Payment notes',
      section3Item1: '3.1 Installment is provided by the issuing bank; limits and rules per bank.',
      section3Item2: '3.2 If installment fails (limit, card status, etc.), full payment applies without interest-free benefit.',
      section4Title: '4. Other',
      section4Item1: '4.1 We may adjust installment rules; updated rules will be posted on the page.',
      section4Item2: '4.2 Questions: contact support at 4007659936',
      effectiveDate: 'Effective: Feb 2026',
      confirm: 'Confirm',
      cancel: 'Cancel',
      agreeRequired: 'Please read and agree to the Installment Terms',
      periodConfirmTitle: 'Notice',
      periodConfirmMsg: 'Selected hotel does not support 3-month installment. Reselect or continue?',
      reselect: 'Reselect',
      continue: 'Continue',
    },
    popup: {
      collapse: 'Collapse',
      loading: 'Loading...',
      stopStationsTitle: 'Stop stations',
      loadingStopStations: 'Loading stop stations...',
      stopNotice: 'Subject to actual train operation; follow station announcements',
      stationName: 'Station',
      arrive: 'Arrive',
      depart: 'Depart',
      stopover: 'Stop',
      stopMinutes: 'Stop {minutes} min',
      actionCancel: 'Cancel',
    },
    planeRefund: {
      title: 'Change, refund & baggage',
      refundRulesTitle: 'Refund fees',
      airlinePolicyOriginal: 'Airline policy (original)',
      adult: 'Adult',
      child: 'Child',
      adultChild: 'Adult & child',
      currentPeriod: 'Current period',
      perPerson: '/person',
      timeColumn: 'Time',
      summaryColumn: 'Summary',
      fuelOnlyRefund: 'Airport & fuel tax only',
      changeRulesTitle: 'Change fees',
      transferRulesTitle: 'Transfer to other airlines',
      luggageRulesTitle: 'Free baggage allowance',
      noRefundInfo: 'No change/refund info available',
      fetchFailed: 'Failed to load change/refund info',
    },
    refundRules: {
      trainTitle: 'Refund & change policy',
      refundFeeTitle: 'Refund fee standard',
      railwayFeeLabel: 'Railway refund fees:',
      refundRule1: '1) 8+ days before departure: free refund',
      refundRule2: '2) 48+ hours before: 5% of fare',
      refundRule3: '3) 24–48 hours before: 10% of fare',
      refundRule4: '4) Less than 24 hours: 20% of fare',
      refundRule5: '5) Online refund stops 2 hours after departure',
      noteLabel: 'Notes:',
      note1: '1) Refund fees collected by railway authority;',
      note2: '2) Minimum fee 2 CNY;',
      note3: '3) Tickets within 7 days changed to 8+ days then refunded: 5% fee;',
      note4: '4) Fees after successful booking are non-refundable;',
      note5: '5) Platform adds 17 CNY refund fee per person (excl. 12306);',
      note6: '6) Refund within ~7 business days.',
      changeRulesTitle: 'Change rules',
      platformChangeFee: 'Note: platform adds 17 CNY change/refund fee per person (excl. 12306)',
      springFestivalNotice: 'Spring Festival travel date changes: 20% refund fee on subsequent refund',
      changeBasicTitle: '1. Basic change rules',
      changeBasicIntro: 'Change applies when altering date, time, train, seat, or destination.',
      changeOnceOnly: 'One change allowed per ticket',
      changeBasicSuffix: ', subject to capacity:',
      changeRule1: '1) 48+ hours before: free change within presale period.',
      changeRule2: '2) Under 48 hours: free change to earlier date on ticket.',
      changeRule3: '3) Under 48 hours: change to later presale date with fee.',
      changeRule4: '4) After departure, before midnight: free change to same-day trains.',
      changeRule5: '5) After departure, before midnight: change to later presale with fee.',
      changeRule6: '6) Destination change: 48+ hours before; handle checked baggage.',
      changeStationNotice: 'Destination change requires 48+ hours before departure.',
      reimbursementTitle: '2. Reimbursement voucher',
      reimbursementContent: 'Printed voucher or cash-paid tickets: change at station window only,',
      returnVoucher: 'voucher must be returned',
      priceDiffTitle: '3. Fare difference',
      priceDiffContent: 'Higher fare: pay difference; lower fare: refund difference minus refund fee.',
      afterDepartureTitle: '4. After-departure change',
      noRefundAfterChange: 'Tickets changed after departure cannot be refunded.',
      changeRefundDiffTitle: '5. Change refund difference fees',
      changeRefundDiffIntro: 'Refund fee on fare difference:',
      changeRefundDiff1: '1) 8+ days before: no fee',
      changeRefundDiff2: '2) 48h–8 days: 5% of fare',
      changeRefundDiff3: '3) 24–48 hours: 10% of fare',
      changeRefundDiff4: '4) Under 24 hours: 20% of fare',
      specialCasesTitle: 'Special cases',
      specialCase1: '1) Illness, expired student ID, etc. per regulations',
      specialCase2: '2) Cancellation, 2h+ delay: free refund',
      specialCase3: '3) Refund within 7 business days (bank processing)',
      specialCase4: '4) Subject to latest railway announcements',
      tipsTitle: 'Reminder',
      tipsContent: 'Based on China Railway 12306 rules; subject to official updates.',
    },
    status: {
      detailFallback: 'Order details',
      countdownRemaining: '{time} left',
      countdownExpired: 'Expired',
      orderNo: 'Order No.: {orderNo}',
      orderTime: 'Order time: {time}',
      copy: 'Copy',
      paySoon: 'Please complete payment soon',
      paidSuccess: 'Payment successful',
      cancelled: 'Order cancelled',
      completed: 'Order completed',
      today: 'Today',
      tomorrow: 'Tomorrow',
      dayAfterTomorrow: 'Day after tomorrow',
      sunday: 'Sun',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      empty: 'No order information',
    },
    dialog: {
      tipTitle: 'Notice',
      flightNotExist: 'Selected flight no longer available. Please reselect.',
      backReselect: 'Reselect',
      priceChangeTitle: 'Price change',
      trainPriceChanged: 'Train price updated to {amount} CNY/person. Continue payment?',
      planePriceChanged: 'Flight price updated: adult {adultPrice}, child {childPrice} CNY/person. Continue?',
      continuePay: 'Continue payment',
      cancelOrderTitle: 'Cancel order',
      cancelOrderMsg: 'Cancel this bundle order? This cannot be undone.',
    },
    toast: {
      maxSeats: 'Select at most {count} seats',
      maxBerths: 'Select at most {count} berths',
      stopStationFailed: 'Failed to load stop stations',
      queryStopStationFailed: 'Failed to query stop stations',
      travelerListFailed: 'Failed to load traveler list',
      selectCouponFailed: 'Failed to apply coupon',
      fillGuestName: 'Please enter guest name',
      fillContactPhone: 'Please enter contact phone',
      phoneNoMask: 'Phone cannot contain asterisks; please update contact info',
      submitCombinedFailed: 'Failed to submit bundle order',
      submitFailed: 'Failed to submit order',
      orderExpired: 'Order data expired; please reselect',
      hotelInfoFailed: 'Failed to load hotel info',
      orderNoEmpty: 'Order number is required',
      fetchDetailFailed: 'Failed to load order details',
      cancelSuccess: 'Order cancelled',
      cancelFailed: 'Failed to cancel order',
      addressCopied: 'Address copied',
      missingOrderNo: 'Missing order number',
    },
    common: {
      perPerson: '/person',
      dash: '--',
      unknownOrderType: 'Unknown order type',
    },
  },
}
